/**
 * Sizing shared by the blocks a meeting plan is drawn with, wherever they are rendered: the plan of
 * a meeting, and the editor of the plan a company writes its meetings from.
 */

/** Block title: 24px medium, the `text-2xl` step. Sizing only —
 *  the navy colour is not a Tailwind class here because a `Heading`/`Text` `color` prop always
 *  wins over any class via its inline `style`, so callers must pass `color={Colors.NAVY}`
 *  themselves instead of relying on a class embedded in this constant. */
export const MEETINGS_TITLE = 'text-[24px] font-medium';
